import type { RateTier, Season } from '../../types/electricity'
import { useLanguage } from '../../i18n/LanguageContext'
import { LanguageToggle } from './LanguageToggle'

export function Header({ tier, season }: { tier?: RateTier; season?: Season }) {
  const { t } = useLanguage()

  const titleGradient = tier === 'peak' ? 'text-gradient-red' : tier === 'offpeak' ? 'text-gradient-green' : 'text-gradient-yellow'

  return (
    <header className="text-center mb-4 relative">
      <LanguageToggle />
      <h1 className={`font-heading text-2xl font-bold ${titleGradient}`}>
        {t('header.title') as string}
      </h1>
      <p className="text-slate-400 text-sm font-body">
        {t('header.subtitle') as string}
      </p>
      <p className="text-slate-500 text-xs font-body mt-2 max-w-sm mx-auto leading-relaxed">
        {t('footer.about') as string}
      </p>
      {season === 'transition' && (
        <p className="text-amber-400/80 text-xs font-body mt-2">
          {t('header.transitionNote') as string}
        </p>
      )}
    </header>
  )
}
